import { Grid, TextField } from '@mui/material';
import * as Constant from 'common/Constant';
import { Controller, useFormContext } from 'react-hook-form';

const LookupDetail = () => {

  const { control } = useFormContext();

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={6}>
          <Controller
            rules={{
              required: Constant.ERROR_MSG_REQUIRED_FIELD
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                id="input-name"
                fullWidth
                {...field}
                required
                error={error}
                helperText={error ? error.message : null}
                label="Name"
              />
            )}
            name="name"
            control={control}
          />
        </Grid>
        <Grid item xs={6}>
          <Controller
            name="code"
            rules={{ required: Constant.ERROR_MSG_REQUIRED_FIELD }}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                fullWidth
                {...field}
                required
                error={error}
                helperText={error ? error.message : null}
                label="Code"
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
};
export default LookupDetail;
